var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('action',_vm._g({attrs:{"action":{ action: 'wait', clientData: {} },"showText":false,"showTyping":""},scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('span')]},proxy:true}])},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }